import React from 'react';
import { Button, ButtonVariant, Modal } from '@usealloy/component-library';

import { useAppSelector } from '~/store/reduxHooks';
import { selectCanSaveWorkflow } from '~/dashboard/views/workflows/store/redux/selectors';


type SaveRequiredModalProps = {
  isOpen: boolean;
  onClose: () => void;
  saveVersion: () => void;
};

export const SaveRequiredModal: React.FC<SaveRequiredModalProps> = ({
  isOpen,
  onClose,
  saveVersion,
}) => {
  const canSaveWorkflow = useAppSelector(selectCanSaveWorkflow);
  const closeButton = <Button onClick={onClose}>Cancel</Button>;
  const saveButton = (
    <Button
      disabled={!canSaveWorkflow}
      onClick={saveVersion}
      variant={ButtonVariant.primary}
    >
      Save in New Editor
    </Button>
  );
  return (
    <Modal
      hasCloseIcon={false}
      header="Saving in New Workflow Editor Required"
      isOpen={isOpen}
      onClose={onClose}
      primaryAction={saveButton}
      secondaryAction={closeButton}
      size="small"
    >
      Threshold Simulator is only available in the new editor,
      please save this workflow in the new editor to use Threshold Simulator.
      You are currently in view-only mode of the new editor.
    </Modal>
  );
};
